import React, { useEffect } from "react";
import { useLocation } from "react-router";
import allowedRoutesWhileAccountIsSuspended from "@/shared/utils/allowedRoutesWhileAccountIsSuspended";
import { useAccount } from "@/features/workspace/hooks/useAccount";

interface AccountFrozenOverlayProps {
  children: React.ReactNode;
}

export default function AccountFrozenOverlay({
  children,
}: AccountFrozenOverlayProps) {
  const { account } = useAccount();
  const route = useLocation();

  const isFrozen = account?.config?.frozen === true;

  useEffect(() => {
    if (isFrozen) {
      const root = document.getElementById("root");
      root?.classList.add("suspended");
    }
  }, [isFrozen]);

  const routeIsBlocked =
    route.pathname &&
    !allowedRoutesWhileAccountIsSuspended.includes(
      route.pathname.split("/")[1]
    );

  if (isFrozen && routeIsBlocked) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/80 backdrop-blur-sm">
        {children}
      </div>
    );
  }

  return <>{children}</>;
}
